import {
  GET_CONTAINERS,
  GET_CONTAINERS_ERROR,
  GET_CONTAINERS_SUCCESS,
  RESET_CONTAINER_FLAG,
} from "./actionTypes"

export const getContainers = bookingNo => {
  return {
    type: GET_CONTAINERS,
    payload: { bookingNo },
  }
}

export const getContainersSuccess = ({ containers, type }) => {
  return {
    type: GET_CONTAINERS_SUCCESS,
    payload: { containers, type },
  }
}

export const getContainersError = error => {
  return {
    type: GET_CONTAINERS_ERROR,
    payload: { error },
  }
}

export const resetContainerFlag = () => {
  return {
    type: RESET_CONTAINER_FLAG,
  }
}
